module.exports = __webpack_public_path__ + "img/deskshelf04.2f81a2c5.jpg";